import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * Badge — small inline status / category indicator.
 * Pencil: Badge/{Success,Warning,Error,Info,Neutral,Primary,Outlined,Outlined/Success}
 */
export const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-pill font-medium text-caption leading-none transition-colors',
  {
    variants: {
      variant: {
        neutral: 'bg-ia-elevated text-ia-text',
        primary: 'bg-primary text-primary-foreground',
        success: 'bg-ia-success-bg text-ia-success',
        warning: 'bg-ia-warning-bg text-ia-warning',
        error: 'bg-ia-error-bg text-ia-error',
        info: 'bg-ia-info-bg text-ia-info',
        outlined: 'bg-transparent text-ia-text border border-ia-border',
        'outlined-success': 'bg-transparent text-ia-success border border-ia-success',
      },
      size: {
        sm: 'h-5 px-2',
        md: 'h-6 px-3',
      },
    },
    defaultVariants: { variant: 'neutral', size: 'md' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant, size }), className)} {...props} />
  ),
)
Badge.displayName = 'Badge'
